import { FORCE_DISABLE_LOOSE_ETAG } from './constants';

export function forceDisableLooseEtag(bool) {
  return {
    type: FORCE_DISABLE_LOOSE_ETAG,
    payload: bool,
  };
}
